import React, { useState } from "react";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import TrackedButton from "web/react/components/tracked-button/tracked-button";
import { gettext } from "web/script/modules/django-i18n";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./brand-ad-container.css";

interface BrandAdContainerProps {
    bannerImage: string;
    brandLogo: string;
    brandName: string;
    link: string;
    mpuImage: string;
    productImage?: string;
    productLink?: string;
    productDescription?: string;
}

function BrandAdContainer({
    bannerImage,
    brandLogo,
    brandName,
    link,
    mpuImage,
    productImage,
    productLink,
    productDescription,
}: BrandAdContainerProps): null | JSX.Element {
    const [isActive, setIsActive] = useState(false);

    function toggleInfo(): void {
        analytics.event("brand_ads", "click", "perf_brand_ad_icon");
        setIsActive(!isActive);
    }

    return (
        <div className={styles.container}>
            <div className={styles.brandLogo}>
                {productImage && productLink && (
                    <TrackedButton
                        className={styles.brandLogoLink}
                        href={productLink}
                        eventCategory="brand_ads"
                        eventAction="click"
                        eventLabel="perf_brand_product_image"
                    >
                        <div className={styles.productDetailsContainer}>
                            <span
                                className={classnames(
                                    styles.productDetails,
                                    styles.productDetailsHeader
                                )}
                            >
                                {gettext("feed.header.featured_label")}
                            </span>
                            <span className={styles.productDetails}>{productDescription}</span>
                        </div>
                        <img
                            className={classnames(styles.containerImage, styles.brandLogoImage)}
                            src={productImage}
                            alt={productDescription}
                        />
                    </TrackedButton>
                )}
                {!productImage && !productLink && (
                    <img
                        className={classnames(styles.containerImage, styles.brandLogoImage)}
                        src={brandLogo}
                        alt={brandName}
                    />
                )}
            </div>
            <TrackedButton
                className={styles.bannerLink}
                href={link}
                eventCategory="brand_ads"
                eventAction="click"
                eventLabel="perf_brand_ad_banner"
            >
                <picture>
                    <source media="(max-width: 599px)" srcSet={mpuImage} />
                    <source media="(min-width: 600px)" srcSet={bannerImage} />
                    <img className={styles.containerImage} src={bannerImage} alt="test banner" />
                </picture>
            </TrackedButton>
            <button
                className={classnames(styles.info, {
                    [styles.active]: isActive,
                })}
                onClick={toggleInfo}
            >
                <span className={styles.infoIcon}>{"i"}</span>
                <span className={styles.infoLabel}>{gettext("feed.header.sponsored_label")}</span>
            </button>
        </div>
    );
}

export default BrandAdContainer;
